import { createContext } from 'react';
import clamp from 'lodash/clamp';
import {
  triggerCustomEvent,
  triggerResizeEvent,
  PAGE_RELAYOUT_EVENT,
} from 'utils/html';
import { xmLocalStorage } from '@xmatters/common/utils/xmStorage';
import {
  GEOMETRY_STORAGE_KEY,
  MAX_HEIGHT,
  MIN_HEIGHT,
  MAX_WIDTH,
  MIN_WIDTH,
} from './constants';

function triggerLayoutEvents() {
  triggerResizeEvent();
  triggerCustomEvent(PAGE_RELAYOUT_EVENT);
}

export function triggerRelayouts() {
  triggerLayoutEvents();
  // Allows a moment for the menu to appear/disappear before page content can adapt to the new size
  requestAnimationFrame(triggerLayoutEvents);
}

export const HelpGeometryContext = createContext({});

export const getHelpViewStyling = geometry => ({
  width: `${geometry.width}px`,
  height: `${geometry.height}px`,
  left: `${geometry.x}px`,
  top: `${geometry.y}px`,
});

const getContainedX = (geometry, containerRect) => {
  const { x, width } = geometry;
  const minX = 0; // containerRect.left
  const maxX = containerRect.right - width;
  return clamp(x || 0, minX, maxX);
};

const getContainedY = (geometry, containerRect) => {
  const { y, height } = geometry;
  const minY = 0; // containerRect.top
  const maxY = containerRect.bottom - height;
  return clamp(y || 0, minY, maxY);
};

const getContainedWidth = (geometry, containerRect) => {
  const { width } = geometry;
  const maxWidth = Math.min(MAX_WIDTH, containerRect.width - 20);
  return clamp(width || 0, MIN_WIDTH, maxWidth);
};

const getContainedHeight = (geometry, containerRect) => {
  const { height } = geometry;
  const maxHeight = Math.min(MAX_HEIGHT, containerRect.height - 20);
  return clamp(height || 0, MIN_HEIGHT, maxHeight);
};

export const clampGeometryToViewport = geometry => {
  const containerRect = document.querySelector('body').getBoundingClientRect();

  return {
    x: getContainedX(geometry, containerRect),
    y: getContainedY(geometry, containerRect),
    width: getContainedWidth(geometry, containerRect),
    height: getContainedHeight(geometry, containerRect),
  };
};

const DEFAULT_GEOMETRY = {
  width: 480,
  height: 500,
  x: 200,
  y: 200,
};

export const getStoredHelpGeometry = () => {
  try {
    return clampGeometryToViewport({
      ...DEFAULT_GEOMETRY,
      ...JSON.parse(xmLocalStorage.getItem(GEOMETRY_STORAGE_KEY)),
    });
  } catch (e) {
    return clampGeometryToViewport(DEFAULT_GEOMETRY);
  }
};

export const storeHelpGeometry = geometry =>
  xmLocalStorage.setItem(
    GEOMETRY_STORAGE_KEY,
    JSON.stringify(clampGeometryToViewport(geometry)),
  );
